import React from 'react'

import * as Types from './InputTypes'

const Input = (props) => {
    return React.createElement(Types[props.type], props)
}

export { Input }